<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>The author was born in 1945 and educated in Stourbridge, West Midlands. He married in 1968 and moved to Shropshire in 1971. He had four children, twelve grandchildren and one great-grandchild.</p>
<p>He passed away before the publication of this book at the age of 74 on 24 June 2019.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?0da39afc